const SvgLatency = (props) => (
  <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
    <path
      d="M12.268 15.598a3.332 3.332 0 0 0 3.332-3.332 3.342 3.342 0 0 0-1.666-2.9L3.148 3.125l6.143 10.641a3.34 3.34 0 0 0 2.977 1.833zM12 0C9.828 0 7.8.576 6.036 1.522l2.52 1.394A9.945 9.945 0 0 1 12 2.306c5.302 0 9.6 4.128 9.6 9.221 0 2.548-1.068 4.853-2.808 6.513h-.012a1.116 1.116 0 0 0 0 1.625c.468.45 1.236.45 1.704.012C22.656 17.59 24 14.709 24 11.527 24 5.161 18.627 0 12 0zM0 11.527c0 3.182 1.344 6.063 3.516 8.15a1.242 1.242 0 0 0 1.692-.012 1.116 1.116 0 0 0 0-1.625C3.468 16.369 2.4 14.075 2.4 11.527c0-1.153.228-2.305.648-3.343l-1.452-2.42C.6 7.493 0 9.429 0 11.527z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgLatency
